import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "banner"
};
const _hoisted_2 = {
  class: "banner-item"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "subtitle"
};
const _hoisted_5 = {
  class: "image-list"
};
const _hoisted_6 = {
  class: "ratio-list"
};
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  class: "percentage"
};
const _hoisted_9 = {
  class: "energy"
};
import { ref, watch } from 'vue';
export default {
  __name: 'BannerList',
  props: {
    todayList: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    let props = __props;
    let dataList = ref({});
    watch(() => props.todayList, newValue => {
      dataList.value = newValue;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_carousel, {
        autoplay: true,
        interval: 10000
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item, index) => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (info, index1) => {
              return _openBlock(), _createElementBlock("div", {
                class: "card",
                key: index1
              }, [_createElementVNode("div", _hoisted_3, _toDisplayString(info.name), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(info.subname), 1), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.urlList, (url, urlIndex) => {
                return _openBlock(), _createBlock(_component_el_image, {
                  key: urlIndex,
                  class: "image",
                  fit: "cover",
                  src: url
                }, null, 8, ["src"]);
              }), 128))]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.nutritionList, (eneray, enerayIndex) => {
                return _openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: enerayIndex
                }, [_createElementVNode("span", _hoisted_7, _toDisplayString(eneray.name), 1), _createVNode(_component_el_progress, {
                  class: "progress",
                  "text-inside": false,
                  "stroke-width": 14,
                  percentage: eneray.recommendedValue,
                  "show-text": false,
                  color: eneray.bgColor
                }, null, 8, ["percentage", "color"]), _createElementVNode("span", _hoisted_8, _toDisplayString(eneray.proportion) + "%", 1), _createElementVNode("span", _hoisted_9, _toDisplayString(eneray.value) + _toDisplayString(eneray.unit), 1)]);
              }), 128))])]);
            }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(3 - item.length, i => {
              return _openBlock(), _createElementBlock("div", {
                class: "card",
                key: i
              });
            }), 128))])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]);
    };
  }
};